// extracted by mini-css-extract-plugin
module.exports = {"title":"k_l","cards":"k_v"};